/**
 * Bailey in team chat ("@Bailey who's free?"), for the stand-in. Pure, so
 * it can be tested: the real Bailey answers on the server with the diary,
 * bookings and the chat's history (backend brief, section 9).
 *
 *   who's free / who is around  → everyone's status from the diary
 *   catch me up / summary / what did I miss → the chat's last few messages
 *   anything else                → what Bailey can help with here
 */
import { firstName, statusLine } from './model';

const FREE = /\b(free|around|available|in today|who'?s (in|on))\b/i;
const CATCH_UP = /\b(catch (me )?up|summar|what did i miss|what'?s (been )?happening|recap)\b/i;

function list(names) {
    if (names.length <= 1) return names.join('');
    return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
}

export function baileyAnswer({ text, people, meId, messages }) {
    const ask = String(text || '').replace(/@bailey/i, '').trim();
    if (FREE.test(ask)) {
        const staff = Object.keys(people).map((id) => people[id]).filter((p) => p.kind === 'staff' && p.id !== meId);
        const free = staff.filter((p) => !p.status || p.status.state === 'free').map((p) => firstName(p.name));
        const busy = staff.filter((p) => p.status && p.status.state !== 'free' && p.status.state !== 'off')
            .map((p) => `${firstName(p.name)} (${statusLine(p.status).toLowerCase()})`);
        const off = staff.filter((p) => p.status && p.status.state === 'off').map((p) => firstName(p.name));
        const lines = [];
        lines.push(free.length ? `Free now: ${list(free)}.` : 'Nobody is free right now.');
        if (busy.length) lines.push(`Busy: ${list(busy)}.`);
        if (off.length) lines.push(`Off today: ${list(off)}.`);
        return lines.join(' ');
    }
    if (CATCH_UP.test(ask)) {
        const said = (messages || []).filter((m) => !m.system && !m.auto && !m.deletedAt && m.text && m.authorId !== meId && m.authorId !== 'bailey' && !m.threadRootId).slice(-4);
        if (!said.length) return "Nothing new from the team in here. You're up to date.";
        const lines = said.map((m) => {
            const who = firstName((people[m.authorId] || {}).name) || 'Someone';
            const words = m.text.replace(/\s+/g, ' ').trim();
            return `${who}: ${words.length > 70 ? `${words.slice(0, 68).trim()}…` : words}`;
        });
        return `Here's the latest:\n${lines.join('\n')}`;
    }
    return "I can tell you who's free (\"@Bailey who's free?\") or catch you up on this chat (\"@Bailey catch me up\"). More soon, like finding a booking or moving one.";
}
